export default {

    setLoading: ({commit, dispatch}, bool) => {
        commit("setLoading", bool)
        dispatch("refreshDataStoredOnWindow")
    },

}